import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
import hideicon from './img/ion.svg';
import hideiconDisabled from './img/ion-disabled.svg';

class InputPass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPass: false
    };
  }
showPass = () => {
  this.setState({
    showPass: !this.state.showPass
  });
}
render() {
  return (
    <div className="ResetPassConteiner">
      <span className="ResetPassName">{this.props.caption}</span>
      <input
        className="ResetPass"
        placeholder="Enter your password"
        type={this.state.showPass ? 'text' : 'password'}
        onChange={this.props.onChange}
      />
      <button
        className="show-Resetpass"
        onClick={this.showPass}
      >
        <img src={this.state.showPass ? hideiconDisabled : hideicon} alt="hide" />
      </button>
    </div>
  );
}
}

InputPass.defaultProps = {
  onChange: () => {},
  caption: ''
};

InputPass.propTypes = {
  onChange: PropTypes.func,
  caption: PropTypes.string
};

export default InputPass;



// WEBPACK FOOTER //
// ./src/pages/AdminRestorePass/commponents/inputPass/index.js